import React, { createContext, useContext, useState } from 'react';
import { LabelSuggestionsQuery } from 'graphql/types';

type TimesheetLabelSuggestionContextType = {
  labelSuggestions: LabelSuggestionsQuery | undefined;
  setLabelSuggestions: (
    setLabelSuggestions: LabelSuggestionsQuery | undefined
  ) => void;
  disableSuggestions?: boolean;
  variant?: 'multi-edit' | 'default';
};

export const TimesheetLabelSuggestionContext = createContext<TimesheetLabelSuggestionContextType | null>(
  null
);

export const useTimesheetLabelSuggestionContext = (): TimesheetLabelSuggestionContextType => {
  const value = useContext(TimesheetLabelSuggestionContext);
  if (!value) {
    throw Error('should be called in TimesheetLabelSuggestionContext scope');
  }
  return value;
};

type TimesheetLabelSuggestionContextProviderProps = {
  disableSuggestions?: boolean;
  children: React.ReactNode;
  variant?: 'multi-edit' | 'default';
};

export const TimesheetLabelSuggestionContextProvider: React.FC<TimesheetLabelSuggestionContextProviderProps> = ({
  disableSuggestions = false,
  children,
  variant = 'default'
}: TimesheetLabelSuggestionContextProviderProps) => {
  const [labelSuggestions, setLabelSuggestions] = useState<
    LabelSuggestionsQuery | undefined
  >(undefined);
  const value = React.useMemo(
    () => ({
      labelSuggestions,
      setLabelSuggestions,
      disableSuggestions,
      variant
    }),
    [labelSuggestions, disableSuggestions, variant]
  );

  return (
    <TimesheetLabelSuggestionContext.Provider value={value}>
      {children}
    </TimesheetLabelSuggestionContext.Provider>
  );
};
